<template>
  <div id="app" class="ns-app">
    <Header></Header>
    <main class="ns-main">
      <router-view/>
    </main>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue